import type { QueueState } from './queue-state.type';

/**
 * The initial state object for the upload queue.
 */
export const INITIAL_STATE: QueueState = {
  compressionSummary: null,
  error: null,
  processed: 0,
  progressMap: {},
  rejectedNames: [],
  staged: [],
  status: 'idle',
};
